module.exports = __webpack_public_path__ + "AvertaStd-BoldItalic.svg?947cea8f5f5bdb10452841658f8520da";